export default "__VITE_ASSET__BGWGpdCz__"